export const CHECKOUT_WC_JS_PATH = 'frontend/checkout-wc/js' as const;
